module.exports = __webpack_public_path__ + "img/TextBlockWithImage.4f8a0a37.png";